import React, { useRef, useState, useEffect, useCallback } from 'react'
import styled from 'styled-components'
import { useEffectOnce } from 'usehooks-ts'
import hintArrow from '../../images/hint-arrow.svg'
import hintArrowYellow from '../../images/hint-arrow-yellow.svg'

const TermList = ({
  tenant,
  colorMode,
  mapData,
  setHighlights,
  setIsHovering,
}: {
  tenant?: object
  colorMode?: string
  mapData?: MapData
  setHighlights?: any
  setIsHovering?: any
}) => {
  const [highlightedTerm, setHighlightedTerm] = useState('')
  const [knowsTerms, setKnowsTerms] = useState(false)
  const [wrapperWidth, setWrapperWidth] = useState(0)
  const wrapperRef = useRef<any>()

  const handleScroll = (): void => {
    setHighlightedTerm('')
    setHighlights([])
  }

  useEffect(() => {
    //place hint arrow
    setWrapperWidth(wrapperRef.current ? wrapperRef.current.offsetWidth : 0)
    // console.log('wrapper width:', wrapperRef.current.offsetWidth)
  }, [mapData]) // listen to data change

  useEffectOnce(() => {
    window.addEventListener('userKnowsTerms', onKnowsTerms)
    // remove highlights when scrolling
    window.addEventListener('scroll', handleScroll)
    return () => {
      window.removeEventListener('scroll', handleScroll)
    }
  })

  const rawTerms = mapData?.map((region: any) => {
    const splitTerms = region.andereBegriffe.split(', ')
    return splitTerms.length > 0 ? splitTerms : []
  })
  const terms = rawTerms?.flat().filter(
    // reduce terms to unique values
    (value: any, index: number, array: any) => array.indexOf(value) === index
  )
  //console.log('terms', terms)

  const handleHover = (term: string) => () => {
    // console.log('handle hover:', term)
    setIsHovering(term === 'none' ? false : true)
    // console.log('mapData', mapData)
    const highlightData = mapData?.filter((region: any) => {
      return region.andereBegriffe.includes(term)
    })
    // console.log('highlightData:', highlightData)
    const highlightedRegions = highlightData?.map((region: any) => {
      return region.site_code
    })
    // console.log('highlightedRegions:', highlightedRegions)
    setHighlights(highlightedRegions)
    setHighlightedTerm(term)

    setKnowsTerms(true)
    const setKnowsterms = new CustomEvent('userKnowsTerms', {
      detail: true,
    })
    window.dispatchEvent(setKnowsterms)
  }

  // the function that is called when the event 'knowsYears' is fired
  const onKnowsTerms: any = useCallback((event: CustomEvent) => {
    setKnowsTerms(event.detail)
  }, [])

  return (
    <Termlist>
      {terms && terms.length > 1 && (
        <>
          {!knowsTerms && (
            <Hint
              style={{
                marginLeft:
                  window.innerWidth < 400
                    ? window.innerWidth / 4 + 'px'
                    : window.innerWidth < 711
                    ? window.innerWidth / 5 + 'px'
                    : wrapperWidth < 200
                    ? 80 + 'px'
                    : wrapperWidth > 400
                    ? wrapperWidth / 2 - 20 + 'px'
                    : wrapperWidth / 1.5 + 'px',
              }}
            >
              <div>
                auf der
                <br />
                Karte zeigen
              </div>
              <img
                src={colorMode === 'dark' ? hintArrowYellow : hintArrow}
                alt='hint'
              />
            </Hint>
          )}
          <ul
          /*
            onMouseOver={() => setIsHovering(true)}
            onMouseOut={() => setIsHovering(false)}
            */
          >
            <div>andere Begriffe:</div>
            <div ref={wrapperRef} className='term-wrapper'>
              {terms.sort().map((term: any, index: number) => {
                return (
                  term !== '' &&
                  term !== ' ' && (
                    <li
                      onMouseOver={handleHover(term)}
                      onMouseOut={handleHover('none')}
                      onClick={handleHover(term)}
                      key={'term-' + index}
                      className={highlightedTerm === term ? 'highlighted' : ''}
                    >
                      {term}
                    </li>
                  )
                )
              })}
            </div>
          </ul>
        </>
      )}
    </Termlist>
  )
}
const Termlist = styled.div`
  max-width: 900px;
  margin: -3vh auto 0;
  //laptops
  @media (max-height: 1400px) and (orientation: landscape) {
    max-width: 90vh;
  }
  //mobile
  @media (max-width: 1024px) {
    max-width: 87%;
  }
  text-align: center;
  div {
    font-size: 0.8em;
    display: block;
    width: 100%;
    margin-bottom: 0.4rem;
  }
  ul {
    list-style: none;
    padding-left: 0;
    padding-inline-start: 0;
    .term-wrapper {
      width: fit-content;
      margin: 0 auto;
      display: flex;
      flex-wrap: wrap;
      align-items: center;
      justify-content: center;
      line-height: 2.5rem;
      li {
        background-color: #86837a; // shade of var(--beige-dark-2)
        color: #fff;
        font-weight: 400;
        font-size: 0.875em;

        white-space: nowrap;
        margin: 0 0.4em 0.4em 0;
        padding: 0 0.4em;
        min-width: 1em;
        text-align: center;
        border-radius: 0.2em;
        cursor: pointer;
      }
      li.highlighted {
        background-color: var(--purple-main);
        color: white;
      }
    }
  }
`

const Hint = styled.div`
  position: absolute;
  max-width: 100%;
  left: 0;
  margin-top: -60px;
  margin-left: 100vw; // is set via JS
  div {
    line-height: 1.5rem;
    font-size: 1.3rem;
  }

  text-shadow: 0 0 3px var(--section-background),
    0 0 3px var(--section-background), 0 0 3px var(--section-background),
    0 0 3px var(--section-background), 0 0 3px var(--section-background);
`

export default TermList
